<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">模板管理</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div v-show="activeNames === 'index'" class="se-panel-title">我的模板</div>
        <div v-show="activeNames === 'rztemplate'">
          <el-button plain icon="el-icon-arrow-left" @click="activeNames = 'index'"></el-button>
          <span class="se-panel-title z-padding-left-5-precent ver-sub">模板认证</span>
        </div>
      </div>
      <div class="panel-body clearfix">
        <div v-show="activeNames === 'index'">
          <div class="ub-box z-margin-bottom-20-precent">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="$router.push('/domainAddMod')">创建</el-button>
            <div class="zj-select" style="margin-left: 25px">
              <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchMod">
                <el-select v-model="utype" slot="prepend" placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="个人" value="P"></el-option>
                  <el-option label="企业" value="C"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="SearchMod"></el-button>
              </el-input>
            </div>
          </div>
          <el-table :data="modList" highlight-current-row show-header :row-style="rowClass" v-loading="listLoading" @cell-mouse-enter="tableEnter" @cell-mouse-leave="tableLeave" style="width: 100%;">
            <el-table-column prop="tname" label="模板名称"  align="left">
            </el-table-column>
            <el-table-column prop="uname" label="域名所有人"  align="left">
            </el-table-column>
            <el-table-column prop="utype" label="模板类型"  align="left">
            </el-table-column>
            <el-table-column prop="domain_count" label="域名数"  align="left">
              <template slot-scope="scope">
                <i v-if="!scope.row.num" class="el-icon-loading"></i>
                <span v-if="scope.row.num">{{scope.row.num}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="实名认证状态" align="left" width="150">
              <template slot-scope="scope">
                <i v-if="!scope.row.state" class="el-icon-loading"></i>
                <span v-if="scope.row.state === '实名资料未上传'" class="server-state-cancel">{{scope.row.state}}</span>
                <span v-if="scope.row.state === '实名资料审核中'" class="z-color-a">{{scope.row.state}}</span>
                <span v-if="scope.row.state === '实名审核通过'" class="z-color-green">{{scope.row.state}}</span>
                <span v-if="scope.row.state === '实名资料审核拒绝' || scope.row.state === '实名资料上传注册局失败'" class="z-color-red">{{scope.row.state}}</span>
                <el-popover width="425" placement="bottom-start" trigger="hover">
                  <div>{{ scope.row.reason }}</div>
                  <span v-show="scope.row.reason" slot="reference" class="dialog-help-link name-wrapper" style="top: 31%">
                  </span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="uptime" label="更新时间" align="left" sortable>
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" align="left" width="200">
              <template slot-scope="scope">
                <router-link :to="'/domainEditMod'+'/'+scope.row.tname" class="z-color-a">编辑</router-link>
                &nbsp;&nbsp;
                <span v-if="!(scope.row.num != 0 || scope.row.state === '实名审核通过')" class="z-curPonit z-color-a" @click="ModDelete(scope.row.tname,scope.row.uemail)">删除</span>
                &nbsp;&nbsp;
                <span v-if="scope.row.state === '实名资料未上传' || scope.row.state === '实名资料审核拒绝'" class="z-curPonit z-color-a" @click="ModIdent(scope.row.utype,scope.row.tname,scope.row.uname)">上传实名资料</span>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="" align="center" width="100">
              <template slot-scope="scope">
                <el-button v-if="scope.row.moren === '0' && scope.row.show === true" size="mini" type="success" @click="ModDefault(scope.row.tname)">设为默认</el-button>
                <el-button v-if="scope.row.moren === '1'" size="mini" type="success" disabled>默认模板</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
          </el-pagination>
        </div>
        <div v-show="activeNames === 'rztemplate'">
          <div class="alert-warn">
            资料提交成功后,预计3-5个工作日审核完成,审核完成状态自动更新,请您耐心等待!
          </div>
          <el-form ref="rzForm" label-width="220px" class="renzheng-form">
            <el-form-item label="域名所有人：">
              {{rzForm.uname}}
            </el-form-item>
            <el-form-item v-if="rzForm.utype === '个人'" label="个人证件类型：">
              <el-select v-model="rzForm.Type">
                <el-option
                  v-for="item in Person"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="rzForm.utype === '企业'" label="企业证件类型：">
              <el-select v-model="rzForm.Type">
                <el-option
                  v-for="item in Group"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'SFZ'" label="所有者身份证号：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'HZ'" label="所有者护照号：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'TXZ'" label="港澳居民来往内地通行证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'TWSFZ'" label="台湾居民来往大陆通行证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'GWSFZ'" label="外国人永久居留身份证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>

            <el-form-item v-show="rzForm.Type === 'ORG'" label="组织机构代码证号码：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'YYZZ'" label="工商营业执照号码：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <!--<el-form-item v-show="rzForm.Type === 'TYDMZ'" label="统一社会信用代码证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>-->
            <el-form-item v-show="rzForm.Type === 'BDDH'" label="部队代号：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'JDXKZ'" label="军队单位对外有偿服务许可证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'SYZS'" label="事业单位法人证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'GWCZDJZ'" label="外国企业常驻代表机构登记证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'STDJZ'" label="社会团体法人登记证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'ZJDJZ'" label="宗教活动场所登记证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'MBDJZ'" label="民办非企业单位登记证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'JJDJZ'" label="基金会法人登记证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'LSXKZ'" label="律师事务所执业许可证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'GWZHDJZ'" label="外国在华文化中心登记证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'GWLYDJZ'" label="外国政府旅游部门常驻代表机构批准登记证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'SFXKZ'" label="司法鉴定许可证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'GWJGZJ'" label="外国机构证件：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'SHFWJGZ'" label="社会服务机构登记证书：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'MBXXXKZ'" label="民办学校办学许可证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item v-show="rzForm.Type === 'YLJGXKZ'" label="医疗机构执业许可证：">
              <el-input v-model="rzForm.organ_code"></el-input>
            </el-form-item>
            <el-form-item label=" 所有者证件照片：">
              <div class="ub-box">
                <div class="ub-box">
                  <div class="col-img">
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </label>
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                    </label>
                  </div>
                </div>
                <div class="z-margin-left-15-precent">
                  <p class="gff8 z-font-size-14">JPG格式，大小在50K到5M之间。</p>
                  <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传证件正面照片，
                    <a v-show="rzForm.Type === 'SFZ'" href="https://img.abeiyun.com/img/example_id_front.jpg" target="_blank" class="z-color-a">示例：身份证正面.jpg</a>
                    <a v-show="rzForm.Type === 'HZ'" href="https://img.abeiyun.com/img/example_huzhao_front.jpg" target="_blank" class="z-color-a">示例：护照正面.jpg</a>
                    <a v-show="rzForm.Type === 'TXZ'" href="https://img.abeiyun.com/img/example_txz_front.jpg" target="_blank" class="z-color-a">示例：港澳通行证正面.jpg</a>
                    <a v-show="rzForm.Type === 'BDDH'" href="https://img.abeiyun.com/img/example_jgz_front.jpg" target="_blank" class="z-color-a">示例：军官证正面.jpg</a>
                    <a v-show="rzForm.Type === 'ORG'" href="https://img.abeiyun.com/img/example_org_license.jpg" target="_blank" class="z-color-a">示例：组织机构代码证照片.jpg</a>
                    <a v-show="rzForm.Type === 'YYZZ'" href="https://img.abeiyun.com/img/example_license.jpg" target="_blank" class="z-color-a">示例：营业执照照片.jpg</a>
                    <a v-show="rzForm.Type === 'TYDMZ'" href="https://img.abeiyun.com/img/example_trust_license.jpg" target="_blank" class="z-color-a">示例：机构信用代码证照片.jpg</a>
                  </p>
                  <label for="fileImg1" class="choose-file">选择文件</label>
                  <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
                </div>
              </div>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="submitrForm">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import XdomainCity from 'components/commons/XdomainCity.vue'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import domainService from 'business/domainService.js'
  import {ConvertPinyin} from 'utils/Pinyin'
  import {checkAreaCode,checkAreaCodeFax,IsEmail} from 'utils/areaCodeValidate'
  export default {
    data () {
      return {
        modList:[],
        listLoading:false,
        dialogLoading:false,
        activeNames:'index',
        showimg:false,
        DISTRICTS:[],
        search:'',
        utype:'',
        state:[
          { text: '审核中', value: '审核中' },
          { text: '审核通过', value: '审核通过' },
          { text: '未提交审核', value: '未提交审核' },
          { text: '审核未通过', value: '审核未通过' },
          { text: '黑名单', value: '黑名单' },
        ],
        rzForm:{
          tname:'',
          uname:'',
          utype:'',
          Type:'',
          organ_code:'',
        },
        Person:[
          { "value": "SFZ", "label": "身份证" },
          { "value": "HZ", "label": "护照" },
          { "value": "TXZ", "label": "港澳居民来往内地通行证" },
          { "value": "TWSFZ", "label": "台湾居民来往大陆通行证" },
          { "value": "GWSFZ", "label": "外国人永久居留身份证" },
        ],
        Group:[
          { "value": "ORG", "label": "组织机构代码证" },
          { "value": "YYZZ", "label": "工商营业执照" },
          /*{ "value": "TYDMZ", "label": "统一社会信用代码证书" },*/
          { "value": "BDDH", "label": "部队代号" },
          { "value": "JDXKZ", "label": "军队单位对外有偿服务许可证" },
          { "value": "SYZS", "label": "事业单位法人证书" },
          { "value": "GWCZDJZ", "label": "外国企业常驻代表机构登记证" },
          { "value": "STDJZ", "label": "社会团体法人登记证书" },
          { "value": "ZJDJZ", "label": "宗教活动场所登记证" },
          { "value": "MBDJZ", "label": "民办非企业单位登记证书" },
          { "value": "JJDJZ", "label": "基金会法人登记证书" },
          { "value": "LSXKZ", "label": "律师事务所执业许可证" },
          { "value": "GWZHDJZ", "label": "外国在华文化中心登记证" },
          { "value": "GWLYDJZ", "label": "外国政府旅游部门常驻代表机构批准登记证" },
          { "value": "SFXKZ", "label": "司法鉴定许可证" },
          { "value": "GWJGZJ", "label": "外国机构证件" },
          { "value": "SHFWJGZ", "label": "社会服务机构登记证书" },
          { "value": "MBXXXKZ", "label": "民办学校办学许可证" },
          { "value": "YLJGXKZ", "label": "医疗机构执业许可证" },
        ],
        count:10,
        total:0,
        page:1,
        dataUrl:'',
      }
    },
    components:{
      XdomainCity,
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchMod()
      this.getArea()
    },
    methods:{
      async SearchMod() {
        this.listLoading = true
        let data = 'cmd=mod_list'+
          '&count='+ this.count +
          '&page='+ this.page +
          '&utype='+ this.utype +
          '&keyword='+ this.search
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.data.allcount
          this.modList = vueData.data.content.map((item, index) => {
            return {
              show:false,
              tname:item.tname,
              uname:item.uname,
              utype:item.utype,
              uptime:item.uptime,
              moren:item.moren,
              uemail:'',
              num:this.DomainNum(item.tname) ? false : false,
              state:this.DomainState(item.tname) ? '' : '',
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async DomainNum(tname) {
        let data = 'cmd=mod_dnlist'+
          '&tname='+ tname
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(state.code === '000') {
          this.modList.map((item, index) => {
            if(tname == item.tname){
              item.num = vueData.dnumber
            }
          })
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      async DomainState(tname) {
        let data = 'cmd=mod_smrz_query'+
          '&tname='+ tname
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(state.code === '000') {
          this.modList.map((item, index) => {
            if(tname == item.tname){
              item.state = vueData.status1
              item.uemail = vueData.uemail1
              item.reason = vueData.auditUnpassReason
            }
          })
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      async getArea() {
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
      async submitrForm() {
        this.dialogLoading = true
        let registrantType = this.rzForm.utype === '个人' ? 'I' : 'E'
        let formData = new window.FormData();
        formData.append('cmd', 'mod_smrz_up')
        formData.append('tname', this.rzForm.tname)
        formData.append('uname1', this.rzForm.uname)
        formData.append('organ_code', this.rzForm.organ_code)
        formData.append('file_reg', this.$refs.inputer.files[0])
        formData.append('registrantType', registrantType)
        formData.append('idType', this.rzForm.Type)
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.activeNames = 'index'
              self.SearchMod()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchMod()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchMod()
      },
      tableEnter(row, column, cell, event) {
        row.show = true
      },
      tableLeave(row, column, cell, event) {
        row.show = false
      },
      rowClass: function (row, index) {
        return { "height": "45px" }
      },
      async ModDefault(tname){
        MessageBox.confirm('确定要设置默认?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=mod_default'+
            '&tname='+ tname
          let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchMod()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async ModDelete(tname,uemail) {
        MessageBox.confirm('确认删除模板?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=mod_delete'+
            '&tname='+ tname +
            '&uemail='+ uemail
          let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchMod()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async ModIdent (utype,tname,uname) {
        this.activeNames = 'rztemplate'
        this.rzForm.tname = tname
        this.rzForm.uname = uname
        this.rzForm.utype = utype
        if(utype === '个人') {
          this.rzForm.Type = 'SFZ'
        }
        if(utype === '企业') {
          this.rzForm.Type = 'ORG'
        }
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .renzheng-form .el-input,.el-select {
    width: 440px;
  }

  em{
    font-style: normal;
    font-weight: 500;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
  .server-state-cancel {
    color: #a0a2a3;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/domainMod.vue